/** Investor Details  */
export class InvestorDetails {
    /** kycVerifiedBy */
    kycVerifiedBy: string;
    /** id */
    id: string;
    /** investorId */
    investorId: string;
    /** emailID */
    emailID: string;
    /** mobileNum */
    mobileNum: string;
    /** dateOfBirth */
    dateOfBirth: string;
    /** investorName */
    investorName: string;
    /** fatherName */
    fatherName: string;
    /** motherName */
    motherName: string;
    /** gender */
    gender: string;
    /** marital */
    marital: string;
    /** politicalRelation */
    politicalRelation: string;
    /** placeOfBirth */
    placeOfBirth: string;
    /** birthCountry */
    birthCountry: string;
    /** qualification */
    qualification: string;
    /** incomeType */
    incomeType: string;
    /** incomeSlab */
    incomeSlab: string;
    /** incomeAsOnDate */
    incomeAsOnDate: string;
    /** occupation */
    occupation: string;
    /** OccupationCode */
    OccupationCode: string;
    /** experience */
    experience: string;
    /** taxResiCountry */
    taxResiCountry: string;
    /** taxIDNum */
    taxIDNum: string;
    /** education */
    education: string;
    /** emailOtp */
    emailOtp: string;
    /** mobileOtp */
    mobileOtp: string;
    /** pennyDropBeneficiaryName */
    pennyDropBeneficiaryName: string;
    /** utiInvestorName */
    utiInvestorName: string;
    /** kraMobile */
    kraMobile: string;
    /** kraEmail */
    kraEmail: string;
    /** utiStatus */
    utiStatus: string;
    /** annualIncome */
    annualIncome: string;
    /** otherEducation */
    otherEducation: string;
/** Initializes the component with default values. */
    constructor() {
        this.politicalRelation = 'N';
        this.marital = 'M';
        this.taxResiCountry = 'India';
        this.birthCountry = 'India';
        this.placeOfBirth = 'India';
        this.experience = '0';
        this.education = 'Graduate';
        this.incomeSlab = '1-5 Lacs';
    }
}
